export { default as Pressable } from './Pressable';
export type { PressableProps } from './types';
